<mat-action-list>
    <button mat-list-item (click)="choose('CAMERA')">
        <mat-icon matListIcon>videocam</mat-icon>
        <h3 matLine>Usar camera</h3>        
    </button>
    <button mat-list-item (click)="choose('GALLERY')">
        <mat-icon matListIcon>collections</mat-icon>
        <h3 matLine>Escolher da galeria</h3>
    </button>
</mat-action-list>